/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Maynotberepresented3Inputs */

const en_entity_maynotberepresented3 = /** @type {(inputs: Entity_Maynotberepresented3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`May Not Be Represented`)
};

const de_entity_maynotberepresented3 = /** @type {(inputs: Entity_Maynotberepresented3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darf nicht vertreten werden`)
};

/**
* | output |
* | --- |
* | "May Not Be Represented" |
*
* @param {Entity_Maynotberepresented3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_maynotberepresented3 = /** @type {((inputs?: Entity_Maynotberepresented3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Maynotberepresented3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_maynotberepresented3(inputs)
	return de_entity_maynotberepresented3(inputs)
});
export { entity_maynotberepresented3 as "entity_mayNotBeRepresented" }